import _defineProperty from "/agent/_work/1/s/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _createClass from "/agent/_work/1/s/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/agent/_work/1/s/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
/** Represents an HTTP response. */
export var HttpResponse = /*#__PURE__*/_createClass(function HttpResponse(statusCode, statusText, content) {
  _classCallCheck(this, HttpResponse);
  this.statusCode = statusCode;
  this.statusText = statusText;
  this.content = content;
});
/** Abstraction over an HTTP client.
 *
 * This class provides an abstraction over an HTTP client so that a different implementation can be provided on different platforms.
 */
export var HttpClient = /*#__PURE__*/function () {
  function HttpClient() {
    _classCallCheck(this, HttpClient);
  }
  _createClass(HttpClient, [{
    key: "get",
    value: function get(url, options) {
      return this.send(_objectSpread(_objectSpread({}, options), {}, {
        method: "GET",
        url: url
      }));
    }
  }, {
    key: "post",
    value: function post(url, options) {
      return this.send(_objectSpread(_objectSpread({}, options), {}, {
        method: "POST",
        url: url
      }));
    }
  }, {
    key: "delete",
    value: function _delete(url, options) {
      return this.send(_objectSpread(_objectSpread({}, options), {}, {
        method: "DELETE",
        url: url
      }));
    }
    /** Gets all cookies that apply to the specified URL.
     *
     * @param url The URL that the cookies are valid for.
     * @returns {string} A string containing all the key-value cookie pairs for the specified URL.
     */
    // @ts-ignore
  }, {
    key: "getCookieString",
    value: function getCookieString(url) {
      return "";
    }
  }]);
  return HttpClient;
}();